import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import styled from "styled-components";

const StyledExpansionPanelDetails = styled(ExpansionPanelDetails)`
  padding: 0;
`;

export default StyledExpansionPanelDetails;
